import cc from 'classcat';
import 'element-scroll-polyfill';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import VisibilitySensor from 'react-visibility-sensor';
import { YearsData } from '../stores/YearsData';
import { ArrowIcon } from './ArrowIcon';
import { ActiveYearLink, YearLink } from './YearLink';
import linkStyles from './YearLink.styl';
import styles from './YearSelect.styl';

@(withRouter as ClassDecorator)
@observer
class Years extends React.Component<{ years: YearsData, path: string }> {
    render() {
        const { years, path } = this.props;
        return (
            <React.Fragment>
                {years.data.map(year => (
                    <VisibilitySensor
                        key={year.value}
                        onChange={year.setVisible}
                        offset={{ left: 165, right: 165, top: -50, bottom: -50 }}
                        partialVisibility
                        resizeCheck
                    >
                        <YearLink year={year} path={path} />
                    </VisibilitySensor>
                ))}
            </React.Fragment>
        );
    }
}

@(withRouter as ClassDecorator)
@inject('years')
@observer
export class YearSelect extends React.Component<{ years?: YearsData, path: string }> {
    private scrollBy: (count: number) => (event: React.MouseEvent) => void = direction => e => {
        const { years } = this.props;
        const { scrollElement, leftInvisibleElement, rightInvisibleElement } = years;
        const data = direction > 0 ? rightInvisibleElement : leftInvisibleElement;

        if (!data || !scrollElement) return;

        scrollElement.scrollBy({
            behavior: 'smooth',
            left: direction * data.element.offsetWidth,
        });
    };

    render() {
        const { years, path } = this.props;
        return (
            <div className={styles.container}>
                <div className={styles.scrollerContainer}>
                    <div className={styles.scroller} ref={years.setRef}>
                        <div className={styles.years}>
                            <Years path={path} years={years} />
                        </div>
                    </div>
                    <ActiveYearLink year={years.activeElement} path={path} side={years.activeSide} />
                </div>

                {years.leftInvisibleElement &&
                <button onClick={this.scrollBy(-2)} className={cc([styles.button, linkStyles.active, styles.left])}>
                  <ArrowIcon className={styles.ArrowIcon} />
                </button>
                }
                {years.rightInvisibleElement &&
                <button onClick={this.scrollBy(2)} className={cc([styles.button, linkStyles.active, styles.right])}>
                  <ArrowIcon className={styles.ArrowIcon} />
                </button>
                }
            </div>
        );
    }
}
